// Custom validation function
export const validateForm = (data) => {
  const errors = {};
  if (!data.date) errors.date = "Date is required";
  if (!data.nonvatsale || isNaN(data.nonvatsale) || data.nonvatsale < 0)
    errors.nonvatsale = "Non VAT SALE must be a positive number or zero";
  if (!data.vatsale || isNaN(data.vatsale) || data.vatsale < 0)
    errors.vatsale = "VAT Sale must be a positive number or zero";
  if (!data.vatamount || isNaN(data.vatamount) || data.vatamount < 0)
    errors.vatamount = "VAT Amount must be a positive number or zero";
  if (isNaN(data.cashamount) || data.cashamount < 0)
    errors.cashamount = "Cash Amount must be a positive number or zero";
  if (isNaN(data.bankamount) || data.bankamount < 0)
    errors.bankamount = "Bank Amount must be a positive number or zero";
  if (isNaN(data.lottery) || data.lottery < 0)
    errors.lottery = "Lottery must be a positive number or zero";
  if (isNaN(data.payzone) || data.payzone < 0)
    errors.payzone = "Payzone must be a positive number or zero";
  if (isNaN(data.oyester) || data.oyester < 0)
    errors.oyester = "Oyester must be a positive number or zero";

  if (!errors.cashamount && !errors.bankamount) {
    const totalFieldsSum =
      Number(data.nonvatsale) +
      Number(data.vatsale) +
      Number(data.vatamount) +
      Number(data.lottery) +
      Number(data.payzone) +
      Number(data.oyester);

    const totalCashBank = Number(data.cashamount) + Number(data.bankamount);

    if (totalFieldsSum !== totalCashBank) {
      errors.cashamount =
        "The total of Cash Amount and Bank Amount must equal the sum of other fields.";
      errors.bankamount =
        "The total of Cash Amount and Bank Amount must equal the sum of other fields.";
    }
  }
  return errors;
};

export const validatePurchaseForm = (data, payment) => {
  const errors = {};

  if (!data.date) errors.date = "Date is required";
  // if (!data.title) errors.title = "Title is required";
  if (!data.vendorselection)
    errors.vendorselection = "Vendor selection is required";
  if (isNaN(data.nonvatamount)) {
    errors.nonvatamount = "Amount must be a number";
  }
  if (isNaN(data.vatamount)) {
    errors.vatamount = "Amount must be a number";
  }
  // if (!data.amounttype) errors.amounttype = "Amount type is required";
  if (!data.paymentmethod) errors.paymentmethod = "Payment method is required";
  // if (!data.description) errors.description = "Description is required";

  // Total amount validation
  const totalAmount = Number(data.nonvatamount) + Number(data.vatamount);
  const maxAllowedAmount = payment?.Maximum + payment?.Balance;
  if (totalAmount > maxAllowedAmount) {
    errors.totalamount = `Total amount exceeds available balance (${maxAllowedAmount})`;
  }

  return errors;
};

export const validateExpenseForm = (data) => {
  const errors = {};

  if (!data.date) errors.date = "Date is required";
  if (isNaN(data.vatamount)) {
    errors.vatamount = "VAT Amount must be a number";
  }
  if (isNaN(data.nonvatamount)) {
    errors.nonvatamount = "Non VAT Amount must be a number";
  }
  if (!data.title) errors.title = "Title is required";
  if (!data.paymentmethod) errors.paymentmethod = "Payment method is required";
  // if (!data.description) errors.description = "Description is required";

  return errors;
};
